export default __webpack_public_path__ + "static/tiles-9-4ed3db9025fe2578664f2ccec24b2dbc.webp";